import { createSelector } from 'reselect';
import { denormalize } from 'normalizr';

import * as schemas from 'store/common/schemas';
import * as entitySelectors from 'store/entities/selectors';

const votingRoundsEntities = createSelector(
  entitySelectors.selectAllEntities,
  entities => entities.votingRounds
);

export const selectVotingRounds = createSelector(
  entitySelectors.selectAllEntities,
  votingRoundsEntities,
  (votingRoundsEntities, votingRoundsById) =>
    denormalize(Object.keys(votingRoundsById), [schemas.votingRound], votingRoundsEntities)
);

export const selectVotingRoundById = createSelector(
  entitySelectors.selectAllEntities,
  (state, props) => props.id,
  (entities, id) => denormalize(id, schemas.votingRound, entities)
);
